import { Validators } from 'utils';
import { normalizeAbn } from 'utils/validators';
import { BusinessInfoProps } from 'types/interfaces/sign-up/MerchantApplication.types';
import { Selectable } from '@zip/business-components';
export { normalizeAbn };
export { SIGN_UP_ERROR_MESSAGES as ERROR_MESSAGES };

export const SIGN_UP_ERROR_MESSAGES = {
  ABN_REQUIRED: 'Please enter ABN',
  ABN_INVALID_LENGTH: 'Your ABN must be 11 digits. Please try again.',
  ABN_INVALID: 'Please enter a valid ABN.',
  ABN_FAILED_TO_LOAD: 'Unable to look up ABN. Please try again.',
  ABN_ALREADY_EXISTS: 'Your ABN already has an existing account. Please login.',
  INDUSTRY_TYPES_NOT_FOUND: 'No industry types available',
  EMAIL_ALREADY_EXISTS:
    'This email is already linked to an account or application. Log in to continue.',
  AI_SUGGESTION_NOT_FOUND: (field: string) =>
    `We couldn’t find your ${field}. Please enter it manually.`,
} as const;

export const businessInfoInitialValues: BusinessInfoProps = {
  abn: '',
  entityName: '',
  entityType: '',
  tradingName: '',
  tradingSince: undefined,
  industryType: '',
};

export const ABN_ERROR_MAP = {
  'invalid-length': SIGN_UP_ERROR_MESSAGES.ABN_INVALID_LENGTH,
  'invalid-checksum': SIGN_UP_ERROR_MESSAGES.ABN_INVALID,
} as const;

export const getAbnValidation = (value: string) => {
  const cleanAbn = normalizeAbn(value);
  const { isValid, error } = Validators.validateAbn(cleanAbn);

  return {
    cleanAbn,
    isValid,
    error,
  };
};

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const UX_MIN_LOADING_TIME_MS = {
  CHECK_ABN_EXISTS: 2000,
  ENTITY_NAME: 2000,
  TRADING_NAME: 1000,
  INDUSTRY_TYPE: 1000,
} as const;

export const API_TIMEOUT_MS = {
  CHECK_ABN_EXISTS: 10000,
  ENTITY_NAME: 10000,
  TRADING_NAME: 10000,
  INDUSTRY_TYPE: 10000,
} as const;

export const getValidIndustrySuggestionsFromOptions = (
  options: Selectable[],
  industryTypes?: string[]
): string[] => {
  if (!Array.isArray(industryTypes) || !options.length) {
    return [];
  }

  const validOptionValues = new Set(options.map((opt) => opt.value));

  return industryTypes
    .filter(Boolean)
    .filter((item: string) => validOptionValues.has(item))
    .slice(0, 3);
};
